export default router => {
  if (window._hmt) {
    // 百度统计,window._hmt仅在PROD环境中存在
    router.beforeEach((to, from, next) => {
      let path = to.matched?.length ? to.matched[to.matched.length - 1].path : to.path
      if (path) {
        window._hmt.push(['_trackPageview', router.options.base + path])
      }
      next()
    })
  }
}
